import { Icon } from "../icon";
import "./pagination.css";

interface PaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export default function Pagination({
    page,
    totalPages,
    onPageChange
}: PaginationProps) {

    const getPages = () => {
        const pages: (number | string)[] = [];
      
        if (totalPages <= 7) {
          return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
      
        if (page <= 4) {
          pages.push(1, 2, 3, 4, 5, "...", totalPages);
          return pages;
        }
      
        if (page >= totalPages - 3) {
          pages.push(
            1,
            "...",
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages
          );
          return pages;
        }
      
        pages.push(
          1,
          "...",
          page - 1,
          page,
          page + 1,
          "...",
          totalPages
        );
      
        return pages;
      };

    return (
        <div className="pagination">
            <button
                disabled={page === 1}
                onClick={() => onPageChange(page - 1)}
            >
                <Icon className="pagination-icon" name="chevron-left" size="small"/>
            </button>
            {getPages().map((item, index) =>
                item === "..." ? (
                    <span key={`dots-${index}`} className="pagination-dots">
                    ...
                    </span>
                ) : (
                    <button
                    key={item}
                    className={page === item ? "active" : ""}
                    onClick={() => onPageChange(item as number)}
                    >
                    {item}
                    </button>
                )
            )}
            <button
                disabled={page === totalPages}
                onClick={() => onPageChange(page + 1)}
            >
                <Icon className="pagination-icon" name="chevron-right" size="small"/>
            </button>
        </div>
    );
}